<template>
  <div style="background: #f7f7f7;">
    <section id="course-page" class="course-page-section">
      <div class="container">
        <h2 class="widget-title text-capitalize">初心使命</h2>
        <div class="row">
          <div class="col-md-9" style="color:#000">
            即将上线...
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      queryModel: {}
    }
  },

  created() {
  },

  mounted() {

  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.widget-title {
  font-size: 30px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/home/cxsm.vue